import { HttpStatus as s } from "@hprofits/utils";
import { RequestCancelledError as d, NetworkError as u, HttpError as c, ApiError as l } from "../errors/errors.js";
import "../errors/utils.js";
import { buildErrorMessage as E } from "./utils.js";
const p = () => {
}, o = (r) => (t, n) => {
  const e = n?.skipDisplayError ? p : r.displayError;
  if (t instanceof d) {
    console.warn(t.message);
    return;
  }
  if (t instanceof u) {
    r.handlingStrategy.network(e);
    return;
  }
  if (t instanceof c) {
    if (t.status === s.UNAUTHORIZED) {
      r.handlingStrategy.unauthorized(r.displayError);
      return;
    }
    const { forbidden: a } = r.handlingStrategy;
    if (t.status === s.FORBIDDEN && a) {
      a(e);
      return;
    }
  }
  if (t instanceof l) {
    e(E(t, n?.errorMessageBuilderOverride, r.messages?.unexpected));
    return;
  }
  r.handlingStrategy.unexpected(t, e);
}, h = (r) => {
  const t = o(r);
  return {
    onError: (n, e) => {
      t(n, e.meta);
    }
  };
}, m = (r) => {
  const t = o(r);
  return {
    onError: (n, e, a, i) => {
      t(n, i.meta);
    }
  };
}, H = (r) => ({
  queryCache: h(r),
  mutationCache: m(r)
});
export {
  o as createErrorHandler,
  H as createErrorHandlingCaches,
  m as createMutationCacheConfig,
  h as createQueryCacheConfig
};
//# sourceMappingURL=create-error-handler.js.map
